import { createSlice } from '@reduxjs/toolkit'
import { AppConfig } from './types'

type AppConfigState = {
  config: AppConfig | null
}

export const appConfigInitialState: AppConfigState = {
  config: null,
}

export const appConfigSlice = createSlice({
  name: 'app-config',
  initialState: appConfigInitialState,
  reducers: {
    setAppConfig(state, action: { payload: AppConfig }) {
      state.config = action.payload
    },
  },
})

export const AppConfigActions = {
  ...appConfigSlice.actions,
}

export const AppConfigReducer = appConfigSlice.reducer
